import { SUPPORTED_FILE_TYPES } from "@/constants";
export const sanitizeMarkdownContent = (content) => {
    if (!content)
        return "";
    // Replace custom tags with standard markdown or HTML
    return content
        .replace(/<filename>/g, '<span class="filename">')
        .replace(/<\/filename>/g, "</span>")
        .replace(/<named>/g, '<span class="named">')
        .replace(/<\/named>/g, "</span>");
};
export const formatTextContent = (content) => {
    if (!content)
        return "";
    try {
        const decodedContent = content
            .replace(/\\n/g, "\n")
            .replace(/\\"/g, '"')
            .replace(/^"|"$/g, "");
        // Additional sanitization for PDF content
        if (content.includes("<filename>") || content.includes("<named>")) {
            return sanitizeMarkdownContent(decodedContent);
        }
        return decodedContent;
    }
    catch (error) {
        console.error("Error formatting text content:", error);
        return content;
    }
};
export const formatJSON = (jsonString) => {
    if (!jsonString)
        return "";
    try {
        const parsed = JSON.parse(jsonString);
        return JSON.stringify(parsed, null, 2);
    }
    catch (error) {
        console.error("Error parsing JSON:", error);
        return jsonString;
    }
};
export const formatPDFContent = (content) => {
    if (!content)
        return "";
    try {
        // First try parsing as JSON
        const parsed = JSON.parse(content);
        // Check if the parsed content has the expected structure
        if (typeof parsed.file === "string") {
            return sanitizeMarkdownContent(parsed.file);
        }
        // If parsed successfully but doesn't have expected structure,
        // return the stringified version
        return JSON.stringify(parsed, null, 2);
    }
    catch (error) {
        // If JSON parsing fails, try to clean up the content as text
        console.warn("PDF content parsing failed, treating as text:", error);
        return sanitizeMarkdownContent(formatTextContent(content));
    }
};
export const formatDOCXContent = (content) => {
    if (!content)
        return "";
    try {
        const parsed = JSON.parse(content);
        if (parsed.data && Array.isArray(parsed.data) && parsed.data.length > 0) {
            return sanitizeMarkdownContent(parsed.data[0].file || "");
        }
        return JSON.stringify(parsed, null, 2);
    }
    catch (error) {
        console.warn("DOCX content parsing failed, treating as text:", error);
        return sanitizeMarkdownContent(formatTextContent(content));
    }
};
export const formatContent = (content, fileType, fileExtension) => {
    if (!content)
        return "";
    try {
        switch (fileType) {
            case "text":
                if (fileExtension === "pdf") {
                    return formatPDFContent(content);
                }
                if (fileExtension === "docx") {
                    return formatDOCXContent(content);
                }
                return formatTextContent(content);
            case "json":
                return formatJSON(content);
            default:
                return content;
        }
    }
    catch (error) {
        console.error("Error in formatContent:", error);
        return content;
    }
};
export const getFileType = (extension) => {
    for (const [type, extensions] of Object.entries(SUPPORTED_FILE_TYPES)) {
        if (extensions.includes(extension)) {
            return type;
        }
    }
    return "unknown";
};
